import React from 'react';
import {
  Button, CardBody, Card, Row, Col,
  Form,
  FormGroup, Label,
  Input,
  Container, InputGroup, InputGroupAddon
} from 'reactstrap';
import { Link } from 'react-router-dom';

const PayrunSettings = (props) => {

  return (
    <div className='AttendanceRules'>
      <Container>
        <Row>
          <Col xs="12" md="12" sm="12">
            <Card>
              <CardBody className="">
                <Link style={{ color: '#121127', marginBottom: '10px!important' }} to="/payroll-new/settings" className='text-nowrap'>
                  <i className="fa fa-arrow-circle-left" style={{ color: '#72B566', fontSize: '16px' }} aria-hidden="true"></i> Back to settings management</Link>
                <Form className="form" style={{ marginTop: '60px' }}>
                  <Row>
                    <Col className='col-md'>

                      <FormGroup>
                        <Label htmlFor="paysliptext">Payslip text</Label>
                        <Input
                          type="text"
                          name="Halfdayholiday"
                          id="Halfdayholiday"
                          placeholder="type here"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='col-md pr-0'>
                      <FormGroup>
                        <Label htmlFor="paysliptext" className='text-nowrap'>Local tax rate</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                          <Input placeholder="type here" name="MaximumannualHolidays"
                            id="MaximumannualHolidays" style={{ bordertopleftRadius: '80px 80px' }} />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col className='col-md'>
                      <FormGroup>
                        <Label htmlFor="paysliptext" className='text-nowrap'>Foreigner tax rate</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">%</InputGroupAddon>
                          <Input placeholder="type here" name="MaximumannualHolidays"
                            id="MaximumannualHolidays" />
                        </InputGroup>

                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col className='col-md pr-0'>
                      <FormGroup>
                        <Label htmlFor="paysliptext" className='text-nowrap'>Organisation admin email</Label>
                        <Input
                          type="text"
                          name="MaximumannualHolidays"
                          id="MaximumannualHolidays"
                          placeholder="type here"
                        />
                      </FormGroup>
                    </Col>
                    <Col className='col-md'>

                      <FormGroup>
                        <Label htmlFor="paysliptext" className='text-nowrap'>Contact to transfer pay run money</Label>
                        <Input
                          type="text"
                          name="MaximumannualHolidays"
                          id="MaximumannualHolidays"
                          placeholder="type here"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button
                    color="success"
                    className="bt float-right " type="submit"
                  >Add
                  </Button>
                </Form>

              </CardBody>
            </Card>
          </Col>

        </Row>

      </Container>

    </div>
  );
}

export default PayrunSettings;
